import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { unlockAudio } from "../lib/audio";

export default function Join() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const { user } = useAuth();
  const [code, setCode] = useState(() => (params.get("code") ?? "").toUpperCase());
  const [nickname, setNickname] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => {
    if (user?.nickname && !nickname) setNickname(user.nickname);
  }, [user, nickname]);

  async function go() {
    setErr("");
    await unlockAudio();
    const roomCode = code.trim().toUpperCase();
    try {
      const storedRaw = sessionStorage.getItem("themix_player") || localStorage.getItem("themix_player");
      const stored = storedRaw ? (JSON.parse(storedRaw) as { playerId?: string; code?: string; token?: string; reconnectToken?: string }) : null;
      if (stored?.playerId && stored.code?.toUpperCase() === roomCode && (stored.reconnectToken || stored.token)) {
        nav(`/j/${roomCode}`);
        return;
      }
      const res = await api<{ playerId: string; token: string }>(`/api/lobbies/${roomCode}/join`, {
        method: "POST",
        body: JSON.stringify({ nickname }),
      });
      const blob = JSON.stringify({ ...res, reconnectToken: res.token, code: roomCode });
      sessionStorage.setItem("themix_player", blob);
      localStorage.setItem("themix_player", blob);
      nav(`/j/${roomCode}`);
    } catch (e) {
      setErr(e instanceof Error ? e.message : "Erreur");
    }
  }

  return (
    <div className="grid gap-4 pt-8 max-w-md">
      <h1 className="font-display text-4xl">Rejoindre</h1>
      <input className="rounded-2xl bg-cream text-ink px-4 py-3 uppercase tracking-widest" placeholder="Code" value={code} onChange={(e) => setCode(e.target.value)} />
      <input className="rounded-2xl bg-cream text-ink px-4 py-3" placeholder="Pseudo" value={nickname} onChange={(e) => setNickname(e.target.value)} />
      {err && <p className="text-pink">{err}</p>}
      <button type="button" className="rounded-3xl bg-gold text-ink py-4 font-bold" onClick={() => void go()}>
        Entrer
      </button>
    </div>
  );
}
